import React, { Component } from "react"
import { Form } from "app/forms/form"
import * as Elements from "app/forms/elements"

import thumbnail from "./preview.jpg"

class Poplar extends Component {
  static displayName = "Poplar"
  static style = "form"
  static formats = ["inline", "modal", "slide in"]
  static thumbnail = thumbnail
  static fields = [
    {
      name: "email_address",
      label: "Email address"
    }
  ]

  render() {
    const { elements, styles, ...props } = this.props
    const customFieldCount = elements.custom.length
    const stackedDisplay = customFieldCount > 0
    const { borderRadius: bg_radius = 0 } = styles.forElement("form")

    return (
      <Form {...props} style={styles.forElement("form")}>
        <div
          data-style="full"
          style={{
            "--bg-border-radius": bg_radius / 2 + "px"
          }}
        >
          <div data-element="column" className="formkit-column">
            <Elements.Header
              tag="h2"
              name="header"
              defaults={{ content: "Learn how to take photos like a pro" }}
            />
            <Elements.Content
              className="formkit-content"
              name="content"
              defaults={{
                content:
                  "I’ll send you a simple guide that will boost your photography skills overnight. <br><br>Get the 28-step guide by subscribing below."
              }}
            />
            <Elements.Errors />
            <Elements.CustomFields data-stacked={stackedDisplay}>
              {stackedDisplay && <Elements.AddFieldButton />}
              <Elements.Button
                name="submit"
                group="button"
                defaults={{ content: "Download" }}
              />
            </Elements.CustomFields>
            {!stackedDisplay && <Elements.AddFieldButton />}

            <Elements.Content
              name="disclaimer"
              defaults={{
                content: "We respect your privacy. Unsubscribe at any time."
              }}
            />
            <Elements.BuiltWith background="form" />
          </div>
          <div
            data-element="column"
            style={styles.forElement("background")}
            className="formkit-background"
          />
        </div>
      </Form>
    )
  }
}

Poplar.displayName = "Poplar"

export default Poplar
